import swatchStyle from "../styles/swatch.module.scss";
import {
  formatBrandId,
  formatBrandMaterialName,
  formatBrandMeta,
  getBrandId,
} from "../utilities/brandData";

const PREVIEW_LIMIT = 3;

function ToolTip({ brandData, showToolTip, onOpenMore }) {
  if (!Array.isArray(brandData) || brandData.length === 0) {
    return null;
  }

  const visible = brandData.slice(0, PREVIEW_LIMIT);
  const remaining = brandData.length - visible.length;

  return (
    <div
      className={`${swatchStyle.brandPopover} ${
        showToolTip ? swatchStyle.brandPopoverOpen : ""
      }`}
      role="tooltip"
      aria-hidden={!showToolTip}
    >
      <ul className={swatchStyle.brandPopoverList}>
        {visible.map((item, index) => (
          <li key={`${getBrandId(item) || "brand"}-${index}`}>
            <span className={swatchStyle.brandPopoverName}>
              {formatBrandMaterialName(item)}
            </span>
            <span className={swatchStyle.brandPopoverMeta}>
              {formatBrandMeta(item) || formatBrandId(item)}
            </span>
          </li>
        ))}
      </ul>
      {remaining > 0 ? (
        <button
          type="button"
          className={swatchStyle.brandPopoverMore}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onOpenMore?.();
          }}
        >
          {remaining} more {remaining === 1 ? "entry" : "entries"}
        </button>
      ) : null}
    </div>
  );
}

export default ToolTip;
